























































import Vue, { PropType } from "vue";

import TextConverter from "@/lib/textConverter";
import {
  GetApplicationOffersResponse,
  GetApplicationOffersResponseOffer
} from "@/containers/applicationOffers/api";

const OFFER_TYPE_CSP_DEBUT_TO_PRO = "csp_debut_to_pro";
const OFFER_TYPE_CSP_PRO_TO_EX = "csp_pro_to_ex";
const OFFER_TYPE_CSP_PRO24_TO_PRO_WACOM = "csp_pro_wacom";
const OFFER_TYPE_CSP_PRO_SAMSUNG = "csp_pro_samsung";

export interface ApplicationOffersProps {
  existOtherOffers: boolean;
  lang: any;
  serial: string;
  getApplicationOffers: any;
}

export default Vue.extend({
  name: "vc-application-offers",
  components: {},
  data() {
    return {
      isLoading: true,
      offers: [] as GetApplicationOffersResponseOffer[],
      offerTypeList: {
        cspDebutToPro: OFFER_TYPE_CSP_DEBUT_TO_PRO,
        cspProToEx: OFFER_TYPE_CSP_PRO_TO_EX,
        wacom: OFFER_TYPE_CSP_PRO24_TO_PRO_WACOM,
        samsung: OFFER_TYPE_CSP_PRO_SAMSUNG
      }
    };
  },
  props: {
    existOtherOffers: {
      type: Boolean as PropType<ApplicationOffersProps["existOtherOffers"]>,
      default: false
    },
    lang: {
      type: Object as PropType<ApplicationOffersProps["lang"]>,
      default: () => {}
    },
    serial: {
      type: String as PropType<ApplicationOffersProps["serial"]>,
      default: ""
    },
    getApplicationOffers: {
      type: Function as PropType<
        ApplicationOffersProps["getApplicationOffers"]
      >,
      default: async () => {}
    }
  },
  async mounted() {
    if (this.serial === "") {
      this.isLoading = false;
      return;
    }

    await this.getApplicationOffers({ serial: this.serial }).then(
      (res: any) => {
        this.offers = res.offers as GetApplicationOffersResponseOffer[];
      }
    );
    this.isLoading = false;
  },
  methods: {
    replaceBr(text: string) {
      return TextConverter.replaceBr(text);
    }
  },
  watch: {}
});
